import { lazy } from 'react'

import TagIcon from '@heroicons/react/outline/esm/CursorClickIcon.js'

import { I18nShape } from '@tribeplatform/react-components/i18n'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { HighlightedTags as Component } from './Block.js'
import { HighlightedTagsBlockProps } from './types.js'

const Settings = lazy(() =>
  import('./Settings.js').then(m => ({
    default: m.HighlightedTagsBlockSettings,
  })),
)

export const RegisteredHighlightedTagsBlock = (
  intl: I18nShape,
): RegisteredBlock<HighlightedTagsBlockProps> => {
  const { $t } = intl

  return {
    recommendedName: 'HighlightedTags',
    Component,
    config: {
      type: BlockType.Block,
      deprecated: true,

      displayName: $t({
        id: 'Blocks.HighlightedTags.displayName',
        defaultMessage: 'Highlighted {TAGS_CC}',
      }),
      Settings,
      Icon: <TagIcon />,
      defaultProps: {
        title: $t({
          id: 'Blocks.HighlightedTags.displayName',
          defaultMessage: 'Highlighted {TAGS_CC}',
        }),
      },
    },
  }
}
